import { createFileRoute } from '@tanstack/react-router';
import { PublicTokenPage } from '../../../features/public/routes/PublicTokenPage';

export const Route = createFileRoute('/public/$token/')({
    component: PublicTokenPage,
});
